export default [
  {
    path: '/banco_precos_calculos',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Banco de Precos Historico',
        path: 'historico',
        component: () => import('@/views/bancoPrecosCalculos/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Cálculo de Banco de Preços' }]
        }
      },
      {
        name: 'Banco de Precos Adicionar',
        path: 'edit',
        component: () => import('@/views/bancoPrecosCalculos/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Cálculo de Banco de Preços', path: '/banco_precos_calculos/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Banco de Precos Editar',
        path: 'edit/:id',
        component: () => import('@/views/bancoPrecosCalculos/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Cálculo de Banco de Preços', path: '/banco_precos_calculos/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
